// extracted by mini-css-extract-plugin
export default {"forSticky":"EditHeader_forSticky__2YqNP","title":"EditHeader_title__LgTGj","back":"EditHeader_back__LLmnW"};